import { createSlice } from '@reduxjs/toolkit'
import { accountSearchPost, accountSearchPostAgain } from './account-search.actions'
import { AccountSearchParams } from '@lk/api'

export interface AccountSearchState {
  status: {
    [key: string]: 'idle' | 'loading' | 'loaded' | 'failed'
  }
  data: {
    [key: string]: Record<string, any>
  }
  error: string | null
  prevSearchData: {
    [key: string]: Partial<AccountSearchParams>
  }
}

const initialState = {
  status: {},
  data: {},
  error: null,
  prevSearchData: {},
}

export const accountSearchSlice = createSlice({
  name: 'accountSearchPost',
  initialState,
  reducers: {
    destroyAccounts: (state, action) => {
      state.status[action.payload] = 'idle'
      state.data[action.payload] = []
    },
  },
  extraReducers: {
    [accountSearchPost.pending.toString()]: (state, action) => {
      state.status[action.meta.arg.instanceName] = 'loading'
    },
    [accountSearchPost.fulfilled.toString()]: (state, action) => {
      state.status[action.payload.instanceName] = 'loaded'
      if (action.payload.instanceName) {
        state.prevSearchData[action.payload.instanceName] = action.meta.arg
        state.data[action.payload.instanceName] = action.payload.data
      }
    },
    [accountSearchPost.rejected.toString()]: (state, action) => {
      state.status[action.meta.arg.instanceName] = 'failed'
      state.error = 'Failed to load'
    },
    [accountSearchPostAgain.pending.toString()]: (state, action) => {
      state.status[action.meta.arg] = 'loading'
    },
    [accountSearchPostAgain.fulfilled.toString()]: (state, action) => {
      state.status[action.payload.instanceName] = 'loaded'
      if (action.payload.instanceName) {
        state.data[action.payload.instanceName] = action.payload.data
      }
    },
    [accountSearchPostAgain.rejected.toString()]: (state, action) => {
      state.status[action.meta.arg.instanceName] = 'failed'
      state.error = 'Failed to load'
    },
  },
})

export const accountSearchReducer = accountSearchSlice.reducer

export const { destroyAccounts } = accountSearchSlice.actions
